import React, { useEffect, useState } from 'react';
import { Rating } from 'react-simple-star-rating';
import { toast } from 'react-toastify';
import { Button, Input, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { getProfile } from '../../../actions/profile';
import { sendFeedbackMessage } from '../../../actions/teamswebhooks';

import './Feedback.css';

const Feedback = (props) => {
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const [firstRating, setFirstRating] = useState(0);
  const [secondRating, setSecondRating] = useState(0);
  const [thirdRating, setThirdRating] = useState(0);
  const [message, setMessage] = useState('');
  const [username, setUsername] = useState('');
  const [applicationName, setApplicationName] = useState('Query');

  const getUsername = async () => {
    const user = await getProfile();
    if (user?.data?.admin) {
      setUsername(`${user.data.admin.fname} ${user.data.admin.lname}`);
    }
  };

  const closeFeedback = () => {
    setIsFeedbackModalOpen(false);
    setFirstRating(0);
    setSecondRating(0);
    setThirdRating(0);
    setMessage('');
    setUsername('');
    setApplicationName('Query');
  };

  const submit = () => {
    sendFeedbackMessage({
      firstRating,
      secondRating,
      thirdRating,
      message,
      username,
      applicationName,
      page: window.location.pathname,
    });
    closeFeedback();
    toast.success('Thank you for your valuable opinions.');
  };

  useEffect(() => {
    getUsername();
  }, []);

  return (
    <>
      <span
        onClick={() => setIsFeedbackModalOpen(true)}
        className="feedback-button"
      >
        Feedback
      </span>
      <Modal size="lg" isOpen={isFeedbackModalOpen} toggle={closeFeedback}>
        <ModalHeader toggle={closeFeedback}>Tell us what you think</ModalHeader>
        <ModalBody>
          <div className="p-1">
            <div className="mb-2">
              <b>How did this work for you, please rate from 1 to 5 stars</b>
            </div>
            <div className="d-flex justify-content-between">
              <div className="d-flex align-items-center feedback-question">
                How well does our dashboard meet your needs?
              </div>
              <div>
                <Rating
                  onClick={(rate) => {
                    setFirstRating(rate);
                  }}
                />
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <div className="d-flex align-items-center feedback-question">
                How easily is to find what you're looking for on our dashboard?
              </div>
              <div>
                <Rating
                  onClick={(rate) => {
                    setSecondRating(rate);
                  }}
                />
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <div className="d-flex align-items-center feedback-question">
                How visually appealing is our dashboard?
              </div>
              <div>
                <Rating
                  onClick={(rate) => {
                    setThirdRating(rate);
                  }}
                />
              </div>
            </div>
            <hr />
            <div className="mt-2">
              <div className="mb-1">
                <b>
                  Do you have any other comments about how we can improve our
                  dashboard?
                </b>
              </div>
              <div>
                <Input
                  value={message}
                  onChange={(e) => {
                    setMessage(e.target.value);
                  }}
                  type="textarea"
                  rows="5"
                />
              </div>
            </div>
            <div className="mt-1 float-right">
              <Button.Ripple
                onClick={submit}
                disabled={
                  firstRating == 0 ||
                  secondRating == 0 ||
                  thirdRating == 0 ||
                  !message ||
                  !username
                }
              >
                Send
              </Button.Ripple>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default Feedback;
